import { Save } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const BusinessSaveAction = () => {
  const { isEditing, handleSave } = useProfile();

  if (!isEditing) return null;

  return (
    <div className="pt-4">
      <button
        type="button"
        onClick={handleSave}
        className="w-full bg-[#067978] hover:bg-[#05605f] text-white py-3.5 rounded-xl font-bold text-xs shadow-lg shadow-[#067978]/20 transition-all active:scale-[0.98] flex items-center justify-center gap-2 cursor-pointer"
      >
        <Save size={16} /> Save Business Details
      </button>
    </div>
  );
};

export default BusinessSaveAction;
